import { useCallback, useEffect, useState } from 'react';
import {
  getOfflineSignerAddressForUser,
  setOfflineSignerAddressForUser
} from '../api/offlineSignerPreferences';

/**
 * Loads/saves the public offline signer address for the current user.
 * @param {string | null | undefined} userId
 */
export function usePersistedOfflineSignerAddress(userId) {
  const [signerAddress, setSignerAddressState] = useState('');

  useEffect(() => {
    setSignerAddressState(getOfflineSignerAddressForUser(userId));
  }, [userId]);

  const setSignerAddress = useCallback(
    (value) => {
      setSignerAddressState(value);
      setOfflineSignerAddressForUser(userId, value);
    },
    [userId]
  );

  return [signerAddress, setSignerAddress];
}
